export interface OrderProductName {
  name: string;
}

export const orderProductNameFromResponse = (
  responseData: any,
): OrderProductName => ({
  name: responseData.name,
});
